import ApiClient from "../../api-client";
import { API_URL } from "../../environment";

export const trackeApplication = ({values, dispatch, token }) => {
    return ApiClient.put(`${API_URL}/user/track-application`, values, token, dispatch);
};

export const getTrackeApplication = ({ dispatch, token, clinicId }) => {
    return ApiClient.get(`${API_URL}/user/get-tracked-application?clinicId=${clinicId}`, {}, token, dispatch);
};

export const getAllActivity = ({ dispatch, token ,page, limit }) => {
    return ApiClient.get(`${API_URL}/application/get-all-activity?page=${page}&limit=${limit}`, {}, token, dispatch);
};
